import {
  IconCircleCheck,
  IconCreditCard,
  IconCalendar,
  IconCoin,
  IconArrowUpCircle,
  IconLoader2,
} from "@tabler/icons-react";
import styles from "../subscriptionPayment.module.css";
import Button from "../../../../components/UI/Button/button";
import moment from "moment";
import { currencyFormat, getCurrencySymbol } from "../../../../utils/functions";

export default function PlanHero({ plan, onScrollToPacks, onScrollToPlans }) {
  const isLoaded = plan != null;

  return (
    <div className={styles.planHero}>
      <div className={styles.planHeroLeft}>
        {!isLoaded ? (
          <div className={styles.planHeroLoading}>
            <IconLoader2 size={16} className={styles.spinner} />
            <span>Loading your plan…</span>
          </div>
        ) : plan?.totalCredits > 0 ? (
          <>
            <div className={styles.planHeroLabel}>Your active plan</div>
            <div className={styles.planHeroName}>{plan?.planName}</div>

            <div className={styles.planHeroPillRow}>
              {plan?.isActive && (
                <span
                  className={`${styles.planStatusPill} ${styles.planStatusActive}`}
                >
                  <IconCircleCheck size={11} /> Active
                </span>
              )}
              {plan?.paidUpfront && (
                <span
                  className={`${styles.planStatusPill} ${styles.planStatusBilled}`}
                >
                  <IconCreditCard size={11} /> Paid upfront — no monthly billing
                </span>
              )}
            </div>

            <div className={styles.planHeroMeta}>
              <div className={styles.planHeroMetaItem}>
                <IconCalendar size={15} />
                <span>
                  Valid until:{" "}
                  {moment(plan?.validityPeriod).format("MMM DD, YYYY")}
                </span>
              </div>
              {plan?.topUpRate && (
                <div className={styles.planHeroMetaItem}>
                  <IconCoin size={15} />
                  <span>Top-up rate: {plan?.topUpRate}</span>
                </div>
              )}
            </div>

            <div className={styles.creditProgress}>
              <div className={styles.creditProgressBar}>
                <div
                  className={styles.creditProgressFill}
                  style={{ width: plan?.totalCredits || 0 }}
                />
              </div>
              <div className={styles.creditProgressLabel}>
                <span>{plan?.totalCredits} credits left</span>
                <span>
                  of {plan?.totalCreditsGranted} purchased (
                  {plan?.creditsBreakdown?.plan} plan +{" "}
                  {plan?.creditsBreakdown?.topup} top-up)
                </span>
              </div>
            </div>
          </>
        ) : (
          <p className="text-[#ff001a] text-base">
            {!plan?.planName
              ? "You do not have an active subscription"
              : "You do not have any credit"}
          </p>
        )}

        <div className={styles.planHeroActions}>
          <Button
            variant="glass"
            leftIcon={<IconCoin size={15} />}
            onClick={onScrollToPacks}
          >
            Buy Top-Up
          </Button>
          <Button
            variant="secondary"
            leftIcon={<IconArrowUpCircle size={15} />}
            onClick={onScrollToPlans}
          >
            Upgrade Plan
          </Button>
        </div>
      </div>

      <div className={styles.planHeroRight}>
        {!isLoaded ? (
          <div className={styles.planHeroPriceSkeleton} aria-hidden="true" />
        ) : (
          <>
            <div className={styles.planHeroPrice}>
              <sup>{getCurrencySymbol(plan?.currency)}</sup>
              {currencyFormat(plan?.price)}
            </div>
            <div className={styles.planHeroPeriod}>per year · one payment</div>
          </>
        )}
      </div>
    </div>
  );
}
